import useConceptOptions from './useConceptOptions.hook';
import { StyledConceptOptions } from './ConceptOptions.styled';
import { useContext, useRef } from 'react';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import { GameAssetsContext } from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';
import GameButton from '@/shared/GameComponents/UI/GameAnswerButton/GameButton';

export default function ConceptOptions({}) {
  const game = useContext(GameLoopContext);
  const { state: assets } = useContext(GameAssetsContext);
  const { state, actions } = useConceptOptions({
    game,
    assets,
  });
  const optionsDisabled = game.state.currentAnswerId || game.state.timedOut;
  return (
    <StyledConceptOptions>
      <div className="answers">
        {game.state.currentConcept
          ? game.state.currentConcept.answerOptions.map((answerOption) => (
              <GameButton
                key={answerOption.id}
                type={getButtonType(
                  game.state.currentAnswerId,
                  answerOption.id,
                  game.state.currentConcept.id,
                  state.currentlyPlayingId
                )}
                onClick={
                  optionsDisabled || state.currentlyPlayingId
                    ? () => {}
                    : () => actions.onUserAnswer(answerOption.id)
                }
                disabled={optionsDisabled}
              >
                {answerOption.text}
              </GameButton>
            ))
          : null}
      </div>
    </StyledConceptOptions>
  );
}

function getButtonType(
  currentAnswerId,
  optionId,
  rightAnswerId,
  currentlyPlayingId
) {
  if (currentlyPlayingId) {
    return currentlyPlayingId === optionId ? 'primary' : 'secondary';
  } else {
    switch (true) {
      case currentAnswerId && optionId == rightAnswerId:
        return 'correct';
      case currentAnswerId &&
        optionId == currentAnswerId &&
        optionId !== rightAnswerId:
        return 'incorrect';
      case currentAnswerId && optionId !== currentAnswerId:
        return 'secondary';
      default:
        return 'primary';
    }
  }
}
